import { Injectable } from "@angular/core";
import { HttpService } from "../../utils/services/http.service";
import { Observable } from "rxjs/Observable";
import { ErrorsService } from "../../utils/services/errors.service";

@Injectable()
export class ProfileService {
  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) {}

  /**Function to change password*/
  changePwd(data): Observable<any> {
    return this.httpService
      .post(`changePwd`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**Function to change password*/
  updateDepartInfo(data): Observable<any> {
    return this.httpService
      .put(`employeeUpdate`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**Function to handle error response*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/common/profile/profile.service.ts